import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';
import { PartnerTypeCaption } from './PartnerTypeCaption';
import { PARTNER_TYPE_LABELS } from './utils/labels';
import { getPartnerDisplayName, type PartnerFeeRow } from './utils/partnerFeeRows';

type PartnerFeeItemProps = {
  row: PartnerFeeRow;
  organizationName?: string | null | undefined;
  /** Captions the row with its partner type; set when the deal has both audience and contextual partners. */
  shouldShowPartnerType: boolean;
  children: ReactNode;
};

/** One partner of the pricing details: its name, its partner type when needed, and its fee. */
export const PartnerFeeItem = ({ row, organizationName, shouldShowPartnerType, children }: PartnerFeeItemProps) => {
  const { partnerId, partnerType } = row;

  return (
    <Box
      data-test={`${PARTNER_TYPE_LABELS[partnerType].dataTestPrefix}-${partnerId}`}
      sx={{
        mb: 2,
      }}
    >
      <Typography
        variant="h3"
        sx={{
          mt: 2,
          mb: shouldShowPartnerType ? 0.5 : 2,
        }}
      >
        {getPartnerDisplayName(row, organizationName)}
      </Typography>
      {shouldShowPartnerType ? <PartnerTypeCaption partnerType={partnerType} /> : null}
      {children}
    </Box>
  );
};
